import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Necesito comprar plantas raras?',
  answer: 'No. Todo lo que necesitas está en un supermercado común: ajo, canela, jengibre, clavo, etc.'
}, {
  question: '¿Es seguro para niños?',
  answer: 'Sí, la guía incluye ajustes de dosis para que sea seguro para toda la familia.'
}, {
  question: '¿Cuánto tiempo tardo en ver resultados?',
  answer: 'Los protocolos están diseñados para dar alivio en 10 a 20 minutos tras la ingesta.'
}, {
  question: '¿Es un libro físico?',
  answer: 'No, es un eBook de descarga inmediata para que lo tengas en tu celular justo cuando lo necesites.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-12 md:py-24 px-4 bg-cream-100 relative" data-id="element-20">
      <div className="max-w-3xl mx-auto" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-16" data-id="element-22">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-forest-900 mb-6" data-id="element-23">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-1 bg-amber-500 mx-auto" data-id="element-24"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-25">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-forest-900/10 rounded-sm bg-white overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-26">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-27">
                <span className="font-playfair font-bold text-lg text-forest-900" data-id="element-28">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="text-amber-600 flex-shrink-0 ml-4" data-id="element-29">
                  <ChevronDown size={20} data-id="element-30" />
                </motion.div>
              </button>

              <AnimatePresence initial={false} data-id="element-31">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-32">
                    <div className="px-6 pb-5 pt-0 text-ink-800 font-lora leading-relaxed border-t border-forest-900/5 mt-2" data-id="element-33">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}